<template>
  <div class="css-grid sales-chart__container">
    <ChartMixVendor :entity-data="entityData" :filters="filters"></ChartMixVendor>
    <ChartMixTier :entity-data="entityData" :filters="filters"></ChartMixTier>
  </div>
</template>

<script>
  import ChartMixVendor from './ChartMixVendor.vue';
  import ChartMixTier from './ChartMixTier.vue';

  export default {
    name: 'MixSales',
    components: {
      ChartMixVendor,
      ChartMixTier,
    },
    props: {
      entityData: {},
      filters: {},
    },
  };
</script>
